import React, { useEffect } from 'react';
import WhiteContainer from '../../../components/containers/WhiteContainer';
import List from '../../../components/list/List';
import Loading from '../../../components/loading/Loading';
import text, { formatCurrency } from '../../../text';
import { usePaymentContext } from '../../pages/payment';
import ChargeItem from './ChargeItem';
var ProductInvoice = function() {
    var _usePaymentContext = usePaymentContext(), job = _usePaymentContext.job, isJobLoading = _usePaymentContext.isJobLoading, numBillableItems = _usePaymentContext.numBillableItems, cardHeading = _usePaymentContext.cardHeading, cartItemsAutomatic = _usePaymentContext.cartItemsAutomatic;
    var quote = job === null || job === void 0 ? void 0 : job.quote;
    useEffect(function() {
        console.log(quote);
    }, [
        quote
    ]);
    return /*#__PURE__*/ React.createElement(WhiteContainer, {
        className: "Invoice position-relative"
    }, isJobLoading ? /*#__PURE__*/ React.createElement("div", {
        className: "position-absolute overlay-loader-container"
    }, /*#__PURE__*/ React.createElement(Loading, null)) : null, !quote ? null : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h6", {
        className: "green-1 font-weight--600 mb-0"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "mr-1"
    }, numBillableItems - (numBillableItems > 1 ? 1 : 0), "."), ' ', /*#__PURE__*/ React.createElement("span", null, text('_invoiceType', {
        prefix: cardHeading,
        type: text('Data in the Database')
    }))), /*#__PURE__*/ React.createElement("div", {
        style: {
            paddingLeft: '20px',
            paddingRight: '16px'
        }
    }, /*#__PURE__*/ React.createElement(List, null, cartItemsAutomatic === null || cartItemsAutomatic === void 0 ? void 0 : cartItemsAutomatic.map(function(charge, i) {
        return /*#__PURE__*/ React.createElement(ChargeItem, {
            key: i,
            charge: charge
        });
    }), quote.discounts.map(function(discount, i) {
        var _discount_price;
        return /*#__PURE__*/ React.createElement(List.Item, {
            className: "discount font-pink pl-3 pt-1 font-italic",
            key: i,
            description: discount.display_name,
            value: "—".concat(formatCurrency((_discount_price = discount.price) === null || _discount_price === void 0 ? void 0 : _discount_price.subtotal, quote.currency.name, quote.currency.scale_factor, {}, true))
        });
    })))));
};
export default ProductInvoice;
